import { getCurrentInstance } from "vue";
import gql from "fraql";
import { apolloClient } from "@/plugins/apollo";
import { useTranslation } from "@/plugins/i18next/i18next";
export function useOrderDebtHelper() {
    const instance = getCurrentInstance();
    const { t } = useTranslation();
    async function deletePersonDebtBalance(item, evt) {
        const target = evt.target;
        // @ts-ignore
        const answer = await instance.proxy.$root.$confirm(t("people:ShoppingBasketPage.debtsTab.deleteDebtBalance.heading", "Clear debt balance to organisation"), t([
            "people:ShoppingBasketPage.debtsTab.deleteDebtBalance.question",
            // eslint-disable-next-line no-useless-escape
            `You are going to clear all debts for the user to organisation {\{organisationName}\}. The balance will be set to 0 and removed from the list of debts. All suspensions due to debt will be lifted, if there are no more debts´ records for user. `
        ], {
            organisationName: item.organisation.name
        }));
        if (!answer)
            return;
        try {
            instance.proxy.$mutateLoading.disableButton(target, "icon");
            instance.proxy.$mutateLoading.showLoading(target);
            await apolloClient.mutate({
                mutation: gql `
          mutation personDebtBalanceDelete($id: ID!) {
            personDebtBalanceDelete(input: { id: $id }) {
              personDebtBalance {
                id
                personId
              }
            }
          }
        `,
                variables: { id: item.id },
                update(cache, { data }) {
                    const fieldValue = data.personDebtBalanceDelete.personDebtBalance;
                    const identity = cache.identify(fieldValue);
                    const personIdentity = cache.identify({
                        id: fieldValue.personId,
                        __typename: "Person"
                    });
                    cache.modify({
                        id: personIdentity,
                        fields: {
                            personDebtBalances: function (existing = []) {
                                cache.evict({ id: identity }); // Remove from the cache
                                return existing.filter(x => x.__ref != identity);
                            }
                        }
                    });
                    cache.modify({
                        fields: {
                            personDebtBalances: function (existing = []) {
                                cache.evict({ id: identity }); // Remove from the cache
                                return existing.filter(x => x.__ref != identity);
                            }
                        }
                    });
                }
            });
            // @ts-ignore
            instance.proxy.$root.$snackbar("success", {
                text: t("common:feedbackMessage.removedSuccessfully.text", "Succesfully deleted!")
            });
        }
        catch (error) {
            // @ts-ignore
            instance.proxy.$root.$snackbarServerError(error, { level: "error" });
        }
        finally {
            instance.proxy.$mutateLoading.enableButton(target, "icon");
            instance.proxy.$mutateLoading.hideLoading(target);
        }
    }
    return { deletePersonDebtBalance };
}
